import styled from 'styled-components';
import { Select, Col, Input } from 'antd';
import {CustomSelectBox} from '../../../commonStyles'

export const Box = styled.div`
  background-color: rgba(0, 103, 120, 0.15);
  position: relative;
  padding: 20px 20px !important;
  box-shadow: 0px 10px 10px rgba(225, 225, 225, 0.5);
  animation: slide-up 1s ease;
  @keyframes slide-up {
    0% {
      opacity: 0;
      transform: translateY(-20px);
    }
    100% {
      opacity: 1;
      transform: translateY(0);
    }
  }
  @media (max-width: 991px) {
    margin-top: 60px;
    padding: 20px 20px !important;

    &:before {
      top: -20px;
      left: 50%;
      border: solid transparent;
      content: ' ';
      height: 0;
      width: 0;
      position: absolute;
      pointer-events: none;
      border-color: rgba(136, 183, 213, 0);
      border-bottom-color: rgba(0, 103, 120, 0.15);
      border-width: 10px;
      margin-left: -10px;
    }
  }
`;

export const FilterCol = styled(Col)`
  vertical-align: text-bottom;
  padding-bottom: 1.5625rem;
  max-height: 6.25rem;
  float: none !important;
  display: inline-block !important;
  @media (max-width: 991px) {
    padding:10px 10px;
    display: inline-block !important;
    width: 100%;
  }
`;

export const BottomWrapper = styled.div`
  padding-top: 20px;
  display: flex;
  justify-content: space-between;
`;

export const CloseText = styled.button`
  font-size: ${props => props.theme.fontSize.primary};
  background: none;
  border: none;
  color: ${props => props.theme.fontColors.primary};
  text-decoration: underline;
  font-family: ${props => props.theme.fontFamily.helveticaNeue};
  svg {
    font-size: ${props => props.theme.fontSize.quaternary};
  }
  @media (max-width: 991px) {
    font-size: ${props => props.theme.fontSize.secondary};
  }
`;

export const TabTitles = styled.p`
  font-family: ${props => props.theme.fontFamily.helveticaNeue};
  font-size: ${props => props.theme.fontSize.primary};
  font-style: ${props => props.theme.fontWeight.normal};
  font-stretch: ${props => props.theme.fontStretch.normal};
  line-height: ${props => props.theme.lineHeight.primary};
  letter-spacing: ${props => props.theme.letterSpacing.zero};
  color: ${props => props.theme.fontColors.headingColor};
  margin-bottom: 0.3125rem;
  @media (max-width: 991px) {
    font-size: ${props => props.theme.fontSize.secondary};
    line-height: ${props => props.theme.lineHeight.secondary};
    margin-top:0.3125rem;
  }
`;

export const SelectBox = styled(Select)`
 @media only screen and (max-width: 320px){
width:100% !important;
 }
 @media (min-width: 320px) and (max-width: 768px){
  width:100% !important;
}
 @media only screen and (min-device-width: 1024px) and (max-device-height: 1366px) and (-webkit-min-device-pixel-ratio: 2)  and (orientation: portrait)  {
  width:280px;
}
.ant-select-selection__placeholder, .ant-select-search__field__placeholder, .ant-select-selection--multiple .ant-select-selection__placeholder{
  color:  ${props => props.theme.fontColors.placeholder};
  font-family: ${props => props.theme.fontFamily.helveticaNeue};
  font-size: ${props => props.theme.fontSize.primary};
  font-style: ${props => props.theme.fontWeight.normal};
  font-stretch: ${props => props.theme.fontStretch.normal};
  line-height: ${props => props.theme.lineHeight.primary};
  @media (max-width: 991px) {
    font-size: ${props => props.theme.fontSize.primary};
  }
  @media (min-width: 320px) and (max-width: 768px){
    font-family: ${props => props.theme.fontFamily.helveticaNeue};
    font-size:${props => props.theme.fontSize.secondary};  
     }

}
  .ant-select-selection {
    border-radius: 0px;
  }

  .ant-select-selection__choice__content{
    @media only screen and (min-device-width: 1024px) and (max-device-height: 1366px) and (-webkit-min-device-pixel-ratio: 2)  and (orientation: portrait)  {
      color:  ${props => props.theme.fontColors.placeholder};
      font-family: ${props => props.theme.fontFamily.helveticaNeue};
      font-size:${props => props.theme.fontSize.tertiary}; ;      }
    @media (min-width: 320px) and (max-width: 768px){
      color:  ${props => props.theme.fontColors.placeholder};
      font-family: ${props => props.theme.fontFamily.helveticaNeue};
      font-size:${props => props.theme.fontSize.tertiary}; ;    
       }
  }
  @media (min-width: 320px) and (max-width: 768px){
    .ant-select-selection__rendered {
      margin-left: 8px !important;
    }
  }
  
  .ant-select-selection--multiple .ant-select-selection__rendered {
    height: 40px;
    margin-bottom: -4px;
  }

  .ant-select-arrow {
    top: 0 !important;
    padding: 16px 13px;
    background-color:${props => props.theme.backgroundColor.pill};
    margin: 1px 1px;
    right: 0;
    bottom: 0;
  }

  .ant-select-selection__rendered {
    height: 40px;
    width: ${props => props.width ? `${props.width - 50}px` : "90%"};

  }
  .ant-select-search__field {
    margin-top: -4px;
    height: 40px;
  }

  .ant-select-selection--single {
    height: 40px;
  }

  .ant-select-selection__clear {
    top: 50%;
    margin-right: 30px;
  }

  .ant-select-selection__rendered > ul > li.ant-select-selection__choice {
    margin-top: 8px;
    border-radius: 0px;
  }

  .ant-select-selection--single .ant-select-selection-selected-value {
    margin-top: 4px;
    font-family: ${props => props.theme.fontFamily.helveticaNeue};
    @media (min-width: 320px) and (max-width: 768px){
      color: ${props => props.theme.fontColors.textColor};
      font-family: ${props => props.theme.fontFamily.helveticaNeue};
      font-size: ${props => props.theme.fontSize.secondary};
     }
     @media only screen and (min-device-width: 1024px) and (max-device-height: 1366px) and (-webkit-min-device-pixel-ratio: 2)  and (orientation: portrait)  {
      font-family: ${props => props.theme.fontFamily.helveticaNeue};
      font-size: ${props => props.theme.fontSize.secondary};        }
  }

`;

export const InputBox = styled(Input)`
@media only screen and (min-device-width: 1024px) and (max-device-height: 1366px) and (-webkit-min-device-pixel-ratio: 2)  and (orientation: portrait)  {
  width:280px;
}

@media only screen and (min-width: 768px) and (max-width: 991px) {
  width:100% !important;
  font-size:${props => props.theme.fontSize.secondary};
  line-height: ${props => props.theme.lineHeight.secondary};
 }
  .ant-input{
    font-family: ${props => props.theme.fontFamily.helveticaNeue};
    font-size: ${props => props.theme.fontSize.primary};
    font-style: ${props => props.theme.fontWeight.normal};
    font-stretch: ${props => props.theme.fontStretch.normal};
    line-height: ${props => props.theme.lineHeight.primary};
    @media (max-width: 991px) {
      font-size: ${props => props.theme.fontSize.secondary};
      line-height: ${props => props.theme.lineHeight.secondary};
    }
   
  }
  .ant-input:placeholder-shown{
    font-size:${props => props.theme.fontSize.secondary}; 
    font-family: ${props => props.theme.fontFamily.helveticaNeue};
    font-size: ${props => props.theme.fontSize.primary};
    font-weight: ${props => props.theme.fontWeight.normal};
    font-style: normal;
    font-stretch: ${props => props.theme.fontStretch.normal};
    line-height: ${props => props.theme.lineHeight.primary} !important;
    color: ${props => props.theme.fontColors.placeholder};
    margin-top: 5px;
    padding-left:0px !important;
    @media (max-width: 991px) {
      font-size: ${props => props.theme.fontSize.secondary};
      line-height: ${props => props.theme.lineHeight.secondary};
      font-family: ${props => props.theme.fontFamily.helveticaNeue};
    }
    @media only screen and (min-width: 768px) and (max-width: 991px) {
      font-size: ${props => props.theme.fontSize.secondary};
      line-height: ${props => props.theme.lineHeight.secondary};

     }
  }
  height: 40px;
  border-radius: 0;
`;

export const PoweredBy = styled.span`
  font-family: ${props => props.theme.fontFamily.helveticaNeue};
  font-size: ${props => props.theme.fontSize.quaternary};
  color: ${props => props.theme.fontColors.textColor};
  align-items: center;
  span {
    margin-right: 10px;
    font-size: 10px;
  }
`;
